'use strict';
import { j as e } from "../../external/react/jsx-runtime.js";
import a from "./form.module.scss.js";
import { FontAwesomeIcon as d } from "../../external/@fortawesome/react-fontawesome/index.es.js";
import { faTriangleExclamation as j } from "../../external/@fortawesome/pro-solid-svg-icons/index.js";
import { faChevronDown as p } from "../../external/@fortawesome/pro-regular-svg-icons/index.js";
const g = ({
  placeholder: o = "Select...",
  name: l,
  value: n,
  label: r,
  error: s,
  disabled: t,
  required: m,
  helperText: c,
  options: x,
  ...h
}) => /* @__PURE__ */ e.jsxs("div", { className: a["field-container"], children: [
  r ? /* @__PURE__ */ e.jsxs("div", { className: a["label-container"], children: [
    /* @__PURE__ */ e.jsx("label", { htmlFor: l, children: /* @__PURE__ */ e.jsx("small", { children: r }) }),
    m ? /* @__PURE__ */ e.jsx("span", { className: a.required, children: "*" }) : null
  ] }) : null,
  /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: a["input-container"],
      "data-disabled": t,
      "data-has-error": !!s,
      "data-has-value": !!n,
      children: [
        /* @__PURE__ */ e.jsxs(
          "select",
          {
            id: l,
            name: l,
            value: n,
            disabled: t,
            ...h,
            children: [
              /* @__PURE__ */ e.jsx("option", { value: "", disabled: !0, children: o }),
              x.map((i) => /* @__PURE__ */ e.jsx("option", { value: i.value, children: i.label }, i.value))
            ]
          }
        ),
        /* @__PURE__ */ e.jsx(d, { icon: p })
      ]
    }
  ),
  (s || c) && /* @__PURE__ */ e.jsx("div", { className: "flex items-center gap-2 pl-4 text-sm h-5", children: s ? /* @__PURE__ */ e.jsxs("span", { className: "text-red-error", children: [
    /* @__PURE__ */ e.jsx(d, { icon: j }),
    s
  ] }) : /* @__PURE__ */ e.jsx("span", { className: "text-grey-400", children: c }) })
] });
export {
  g as default
};
